export const B2B_INVITE_DISMISS_KEY_PREFIX = 'eateliers.b2bInvite.dismissedAt.';
export const B2B_INVITE_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

export function b2bInviteDismissedAtKey(tenantId: string): string {
  return `${B2B_INVITE_DISMISS_KEY_PREFIX}${tenantId}`;
}

export function canShowB2bInvite(tenantId: string, now = Date.now()): boolean {
  try {
    const stored = localStorage.getItem(b2bInviteDismissedAtKey(tenantId));
    if (!stored) return true;
    const dismissedAt = Date.parse(stored);
    if (Number.isNaN(dismissedAt)) return true;
    return now - dismissedAt >= B2B_INVITE_COOLDOWN_MS;
  } catch (error) {
    console.error('Failed to read B2B invite dismiss state', { tenantId, error });
    return true;
  }
}

export function markB2bInviteDismissed(tenantId: string, now = new Date()): void {
  try {
    localStorage.setItem(b2bInviteDismissedAtKey(tenantId), now.toISOString());
  } catch (error) {
    console.error('Failed to persist B2B invite dismiss', { tenantId, error });
  }
}
